export const PLATFORM_FEE_RATE = 0.045;
export const CHECKOUT_FEE = 0.28;

function roundCurrency(value) {
  return Number(Number(value || 0).toFixed(2));
}

export function calculatePlatformFee(sellerPayout) {
  return roundCurrency(Number(sellerPayout || 0) * PLATFORM_FEE_RATE);
}

export function calculateSellingPriceFromSellerPayout(sellerPayout) {
  const normalizedSellerPayout = roundCurrency(sellerPayout);
  return roundCurrency(normalizedSellerPayout + calculatePlatformFee(normalizedSellerPayout));
}

export function calculateSellerPayoutForTargetSellingPrice(sellingPrice) {
  const sellingPriceCents = Math.round(Number(sellingPrice || 0) * 100);
  let candidateCents = Math.floor(sellingPriceCents / (1 + PLATFORM_FEE_RATE));

  const calculateSellingPriceCents = (sellerPayoutCents) => {
    const feeCents = Math.round(sellerPayoutCents * PLATFORM_FEE_RATE);
    return sellerPayoutCents + feeCents;
  };

  while (calculateSellingPriceCents(candidateCents + 1) <= sellingPriceCents) {
    candidateCents += 1;
  }

  while (calculateSellingPriceCents(candidateCents) > sellingPriceCents && candidateCents > 0) {
    candidateCents -= 1;
  }

  return roundCurrency(candidateCents / 100);
}

export function calculatePricingFromSellerPayout(sellerPayout) {
  const normalizedSellerPayout = roundCurrency(sellerPayout);
  const platformFee = calculatePlatformFee(normalizedSellerPayout);
  const sellingPrice = roundCurrency(normalizedSellerPayout + platformFee);

  return {
    sellerPayout: normalizedSellerPayout,
    platformFee,
    sellingPrice,
  };
}
